import React, { Component } from 'react';

import SettingsModal from './SettingsModal';
import OnboardingJoyride from '../../../components/Onboarding';
import {
    SEAONAL_SETTINGS_STEPS,
    SEASONAL_FEATURE_SETTINGS,
    SEASONAL_PAGE,
} from '../../../config/_announcement_keys';
import Items from './items';
import Loading from '../../../components/Loading';
import { getSeasonsQuery } from './query';
import { v4 as uuid } from 'uuid';
import { withTranslation } from 'react-i18next';

class GSCReportSeasonalKeywords extends Component {
    constructor() {
        super();
        this.offsetStep = 1000;

        this.getSeasons = this.getSeasons.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onOpenSettingsModal = this.onOpenSettingsModal.bind(this);
        this.onCloseSettingsModal = this.onCloseSettingsModal.bind(this);
        this.onRemoveAllSelected = this.onRemoveAllSelected.bind(this);
        this.getSeasonsItems = this.getSeasonsItems.bind(this);
        this.domain_url = window.filters.get().domain.value;

        this.state = {
            loading: true,
        };
    }

    componentDidMount() {
        this.getSeasonsItems();
    }

    onRemoveAllSelected(bool) {
        this.setState({
            removeAllSelected: bool,
            selectedItems: [],
        });
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({ selectedItems: state.ids, removeAllSelected: false });
    }

    getSeasons(seasons) {
        this.setState({
            seasons,
            loading: false,
        });
    }

    onOpenSettingsModal() {
        this.setState({ isOpen: true });
    }

    onCloseSettingsModal() {
        this.setState({ isOpen: false });
    }

    async getSeasonsItems() {
        try {
            const response = await getSeasonsQuery(this.props.endpoint_url, this.domain_url);
            const items = await response.json();
            const seasons = JSON.parse(items.seasons)?.map((item) => ({ ...item, id: uuid() }));
            const data = seasons?.length !== 0 ? seasons : [{ name: '', keywords: '', id: uuid() }];
            this.getSeasons(data);
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        const { t } = this.props;

        const existingSeasonalKeywords = this.state.seasons?.filter((item) => item.keywords);
        return (
            <>
                {!this.state.loading && !existingSeasonalKeywords?.length && (
                    <div className="actions-btns card-body mt-10 d-flex justify-content-between align-items-center">
                        <div className="box-header">{t('search.custom_keywords.header')}</div>
                        <SettingsModal
                            endpoint_url={this.props.current_url}
                            csrf_token={this.props.csrf_token}
                            getSeasons={this.getSeasons}
                            seasons={this.state.seasons}
                            isOpen={this.state.isOpen ?? false}
                            onOpenSettingsModal={this.onOpenSettingsModal}
                            onCloseSettingsModal={this.onCloseSettingsModal}
                        />
                    </div>
                )}
                {this.state.loading ? (
                    <Loading padding={10} />
                ) : existingSeasonalKeywords?.length !== 0 ? (
                    <Items
                        onOpenSettingsModal={this.onOpenSettingsModal}
                        content_id={this.props.content_id}
                        parent_id={this.props.parent_id}
                        loading={this.state.loading}
                        seasons={existingSeasonalKeywords}
                        onCloseSettingsModal={this.onCloseSettingsModal}
                        current_url={this.props.current_url}
                        getSeasons={this.getSeasons}
                        isOpen={this.state.isOpen ?? false}
                        csrf_token={this.props.csrf_token}
                        selectedItems={this.state.selectedItems?.map((id) => ({
                            id,
                            keyword: this.state.allData.find((item) => item.id === id).keyword,
                        }))}
                        header={t('search.custom_keywords.clusters_header')}
                        cluster_type="keyword"
                        onRemoveAllSelected={this.onRemoveAllSelected}
                    />
                ) : (
                    <div className="w-100 d-flex align-items-center justify-content-center card-body mt-10">
                        <button
                            className="button button-filled button-primary btn d-flex align-items-center justify-content-center"
                            onClick={this.onOpenSettingsModal}
                        >
                            {t('search.custom_keywords.add_keywords_group')}
                        </button>
                    </div>
                )}
                {this.state.allData?.[0] && (
                    <OnboardingJoyride
                        endpoint_url={this.props.current_url}
                        csrf_token={this.props.csrf_token}
                        steps={SEAONAL_SETTINGS_STEPS}
                        page={SEASONAL_PAGE}
                        feature={SEASONAL_FEATURE_SETTINGS}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(GSCReportSeasonalKeywords);
